<template>
  <div class="q-dropdown" data-app>
    <div class="ma-auto">
      <div>
       
        <div class="flex ai-center m-y-4 q-dropdown__item" 
          v-for="(item, key) in data.metadata.variants" :key="key">
          <div 
            v-html="$options.filters.mathformat(item.description)"
            class="text-content">
          </div>

          <div class="select-content m-l-2">
            <v-select
              max-width="80px"
              :items="item.answers"
              name="selecttype"
              label="Выбрать"
              item-text="title"
              item-value="title"
              v-model="current_answers[key]"
              hide-details
              single-line
              outlined
            >
              <template slot="selection" slot-scope="data">
                <span v-html="data.item.title"></span>
              </template>
              <template slot="item" slot-scope="data">
                <span v-html="data.item.title"></span>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="ta-center m-t-10 btn-content">
        <v-btn :loading="loading" @click="answer" class="mt-8" large color="info">
          Ответить на вопрос
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>

// import { setAnswers } from '~/api/worksApi';

export default {
  props: {
    data: Object,
  },
  async created() {

  },
  data() {
    return {
      current_answers: {},
      // text: null,
      status_valid: false,
      loading:false
    }
  },
  watch: {
    select_values(arr){
      if(arr.length == this.data.metadata.variants.length)
        this.status_valid = true
      
    }
  },
  computed: {

  },
  methods: {
    selection(key){
      this.data.metadata.variants[key].answers.forEach(item=>{
        if(item.title == this.current_answers[key])
          item.selected = true
        else
          item.selected = false
      })
      console.log(this.data.metadata.variants[key].answers)
    },
    async answer() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    }
  },
}
</script>
